<template>
    <div class="flex flex-col">
        <input type="text" maxlength="50" v-model="postTitle" placeholder="Add a Title" class="w-11/12 bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:ring-2 focus:bg-transparent focus:ring-green-200 focus:border-green-500 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out mt-3 self-center dark:focus:bg-opacity-10 dark:focus:bg-white dark:bg-opacity-0 dark:text-gray-100"> <br>
        <textarea maxlength="3000" type="text" v-model="postText" placeholder="The facts here 😉" class="w-11/12 bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:ring-2 focus:bg-transparent focus:ring-green-200 focus:border-green-500 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out mt-3 self-center dark:focus:bg-opacity-10 dark:focus:bg-white dark:bg-opacity-0 dark:text-gray-100"> Breh </textarea><br>
        <div v-if="postCreating">
            <img :src="loadingImage" alt="loading..">
        </div>
        <div v-else>
            <button @click="makePost" class=" mt-6 inline-flex text-white bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-green-600 rounded w-fit self-center">Add Post</button>
        </div>
        <!--<button @click="snacc('Salud!')" class=" mt-6 inline-flex text-white bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-green-600 rounded w-fit self-center">Snacc</button>-->
        <div class="border border-solid border-green-500 text-xl font-medium rounded-lg bg-white opacity-0 transition-all w-11/12 bottom-3 fixed self-center pt-2 pb-2 hidden dark:bg-opacity-75 dark:text-gray-600" ref="snackbar">
            {{ navMessage }}
        </div>
    </div>
</template>

<script>
const devServer = process.env.VUE_APP_PROD_SERVER || "http://localhost:3030" ;
export default {
    name: "CreatePost",
    data() {
        return {
            navMessage: "",
            pjwt: {
                token: "",
                username: ""
            },
            postCreating: false,
            loadingImage: require('../assets/Rolling-1s-200px.gif'),
        }
    },
    props: {
        id: String
    },
    created() {
        this.fillJWT();
        this.checkAuth();
    },
    methods: {
        snacc: async function(message) {
            this.navMessage = message;
            //console.log("making the opacity to 1....");
            this.$refs.snackbar.style.display = "block";
            this.$refs.snackbar.style.opacity = 1;
            await setTimeout(() => {
                this.$refs.snackbar.style.opacity = 0;
            }, 3000);
            await setTimeout(() => {
                this.$refs.snackbar.style.display = "none";
            }, 3500);
            //console.log("turned the opacity to 0 again....");
        },


        makePost: async function() {
            this.postCreating = true;
            // create a post, using text from field and
            const bodyData = {
                "text": this.postText,
                "title": this.postTitle,
                "author": this.pjwt.username,
            };
            this.postText = "";
            this.postTitle = "";
            const respomse = await fetch(`${devServer}/api/posts/`, {
                mode: "cors",
                method: "POST",
                headers: {"Content-Type": "application/json", "authorization": `Bearer ${this.id}`},
                body: JSON.stringify(bodyData)
            });

            if(respomse.status == 201) {
                this.snacc("Post Created!");
            } else {
                this.snacc("Some Error Occurreed");
            }
            this.postCreating = false;
        },

        fillJWT: async function() {
            // fill the jwt using the this.id from url
            this.pjwt.token = this.id;
            this.pjwt.username = "joe";
        },

        checkAuth: async function() {
            let respomse = await fetch(`${devServer}/api/auth/checkAuth/`, {headers: {"Content-Type": "application/json", "authorization": `Bearer ${this.pjwt.token}`, mode: "cors"}});
            let res = await respomse.json();
            this.pjwt.username = res.username;
            this.$emit("passJWTToParent", this.pjwt);
        }

    }
}
</script>
